import React, {Component} from 'react';
import QuoteProduct from "../components/quote-product";
import QuoteReview from "../components/quote-review/quote-review";
import QuoteSize from "../components/quote-size/quote-size";
import QuoteSummary from "../components/quote-summary/quote-summary";

const QuotePage = (props) => {
    return (
        <React.Fragment>
            {
                !props.match.params.section && <QuoteProduct />
                ||
                props.match.params.section === 'product' && <QuoteProduct />
                ||
                props.match.params.section === 'size' && <QuoteSize />
                ||
                props.match.params.section === 'review' && <QuoteReview />
                ||
                props.match.params.section === 'summary' && <QuoteSummary />
            }
        </React.Fragment>
    )

}

export default QuotePage;


